import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { CustomDetailsList } from "../../../../../common/customDetailsList/customDetailsList";
import { Skeleton } from "../../../../../common/skeleton/skeleton";
import { MasterActuationTypeFormController } from "../controller/controller";

import { MasterActuationTypeColumns } from "./column/column";
import { SkeletonSizes } from "../../../../../../common/constants";
import { fetchMasterActuationTypeList } from "../../../../../../redux/actions/resources/master/actuationType/actuationType";

interface IMasterActuationTypeListContainerProps {
    widthPopUp: any;
    heigthPopUp: any;
}

export const MasterActuationTypeListContainer: React.FC<IMasterActuationTypeListContainerProps> = ({ heigthPopUp, widthPopUp }) => {
    const { list, loading } = useAppSelector((state) => state.masterActuationTypeList);
    const dispatch = useAppDispatch();
    
    const renderColumns = () => {
        return MasterActuationTypeColumns();
    };
    
    useEffect(() => {
        list === undefined && !loading && dispatch(fetchMasterActuationTypeList());
    }, [list]);

    return (
        <div style={{ height: "100%" }}>
            {loading ? (
                <Skeleton rows={SkeletonSizes.DEFAULT} />
            ) : (
                <CustomDetailsList
                    data={list ?? []}
                    renderColumns={renderColumns}
                    height={"calc(100vh - 10rem)"}
                />
            )}

            <MasterActuationTypeFormController
                widthPopUp={widthPopUp}
                heigthPopUp={heigthPopUp}
            />
        </div>
    );
};
